import { customerBaseApi } from "@/react/services/api";

const PRIMARY_ADMIN_URL = `primary-admin`;
const PRIMARY_ADMIN = "PRIMARY_ADMIN";

export const primaryAdminChangeApi = customerBaseApi.injectEndpoints({
  endpoints: (build) => ({
    changePrimaryAdmin: build.mutation({
      query: (userId) => ({
        url: `${PRIMARY_ADMIN_URL}/${userId}`,
        method: "POST",
      }),
      invalidatesTags: [PRIMARY_ADMIN],
    }),
    getCurrentPrimaryAdmin: build.query({
      query: () => ({
        url: PRIMARY_ADMIN_URL,
        method: "GET",
      }),
      providesTags: [PRIMARY_ADMIN],
    }),
    getUsers: build.query({
      query: () => ({
        url: `${PRIMARY_ADMIN_URL}/users`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetUsersQuery,
  useGetCurrentPrimaryAdminQuery,
  useChangePrimaryAdminMutation,
} = primaryAdminChangeApi;
